import { ThemeUICSSObject } from 'theme-ui';

export const print: ThemeUICSSObject = {
  border: '2px solid',
  borderColor: 'printView.list.table.borderColor',

  'td, th': {
    p: 3,
    textAlign: 'left',
  },
};
